import axios from 'axios';
import authHeader from './auth-header';
import { getUrl } from './service-utils';
import { AddCollaboratorFormModel } from '../components/modals/collaborators/collaborator-add-modal';

const API_URL = getUrl();

export const InviteCollaborator = async (
  invitation: AddCollaboratorFormModel
): Promise<any> => {
  const response = await axios.post(
    API_URL + `trips/${invitation.tripId}/invitations`,
    {
      email: invitation.inviteeEmail,
      role: invitation.invitationRole
    },
    {
      headers: authHeader()
    }
  );
  return response.data;
};

export const AcceptTripInvitation = async (
  tripId: string,
  invitationId: string
): Promise<any> => {
  const response = await axios.patch(
    API_URL + `trips/${tripId}/invitations/${invitationId}/accept`,
    {},
    {
      headers: authHeader()
    }
  );
  return response.data;
};

export const DenyTripInvitation = async (
  tripId: string,
  invitationId: string
): Promise<any> => {
  const response = await axios.patch(
    API_URL + `trips/${tripId}/invitations/${invitationId}/deny`,
    {},
    {
      headers: authHeader()
    }
  );
  return response.data;
};

export const RevokeInvitation = async (
  tripId: string,
  invitationId: string
): Promise<any> => {
  const response = await axios.delete(
    API_URL + `trips/${tripId}/invitations/${invitationId}`,
    {
      headers: authHeader()
    }
  );
  return response.data;
};

export const ResendInvitation = async (
  tripId: string,
  invitationId: string
): Promise<any> => {
  const response = await axios.post(
    API_URL + `trips/${tripId}/invitations/${invitationId}/resend`,
    {},
    {
      headers: authHeader()
    }
  );
  return response.data;
};

export const ListUserInvitations = async (): Promise<any[]> => {
  const response = await axios.get(API_URL + `trips/invitations/pending`, {
    headers: authHeader()
  });
  return response.data.data;
};

export const ListUserSentInvitations = async (): Promise<any[]> => {
  const response = await axios.get(API_URL + `trips/invitations/sent`, {
    headers: authHeader()
  });
  return response.data.data;
};

export const GetTripCollaborators = async (tripId: string): Promise<any[]> => {
  // Get trip to check collaborators/permissions
  const response = await axios.get(API_URL + `trips/${tripId}`, {
    headers: authHeader()
  });
  return response.data.data.permissions || [];
};

export const GetTripPendingInvitations = async (
  tripId: string
): Promise<any[]> => {
  // Get pending invitations for this trip from the user's sent invitations
  const allSentInvitations = await ListUserSentInvitations();
  return allSentInvitations.filter(
    (inv: any) => inv.tripId === tripId && inv.status === 'pending'
  );
};

export const RemovePermission = async (
  tripId: string,
  userId: string
): Promise<any> => {
  const response = await axios.delete(
    API_URL + `trips/${tripId}/permissions/${userId}`,
    {
      headers: authHeader()
    }
  );
  return response.data;
};
